const KB = "taxCalculator.pph2126.knowledgeBase";

export const PPH2126_KB_KEYS = {
  title: `${KB}.title`,
  subtitle: `${KB}.subtitle`,
  sections: [
    {
      type: "intro",
      parts: [
        { text: `${KB}.introPart1` },
        { text: `${KB}.introHighlight1`, bold: true },
        { text: `${KB}.introConnector`, connector: true },
        { text: `${KB}.introHighlight2`, bold: true },
        { text: `${KB}.introPart2` },
      ],
    },
    {
      type: "labeled-list",
      title: `${KB}.whatIs.title`,
      items: [
        { labelKey: `${KB}.whatIs.pph21Label`, descKey: `${KB}.whatIs.pph21Desc` },
        { labelKey: `${KB}.whatIs.pph26Label`, descKey: `${KB}.whatIs.pph26Desc` },
      ],
    },
    {
      type: "list",
      title: `${KB}.withholders.title`,
      description: `${KB}.withholders.description`,
      items: [
        `${KB}.withholders.item1`,
        `${KB}.withholders.item2`,
        `${KB}.withholders.item3`,
        `${KB}.withholders.item4`,
        `${KB}.withholders.item5`,
      ],
    },
    {
      type: "subsections",
      title: `${KB}.ter.title`,
      descParts: [
        { text: `${KB}.ter.descriptionPart1` },
        { text: `${KB}.ter.descriptionHighlight`, bold: true },
        { text: `${KB}.ter.descriptionPart2` },
      ],
      subsections: [
        {
          title: `${KB}.ter.monthly.title`,
          description: `${KB}.ter.monthly.description`,
          layout: "label-desc",
          items: [
            { labelKey: `${KB}.ter.monthly.categoryLabel`, interpolation: { cat: "A" }, descKey: `${KB}.ter.monthly.categoryA` },
            { labelKey: `${KB}.ter.monthly.categoryLabel`, interpolation: { cat: "B" }, descKey: `${KB}.ter.monthly.categoryB` },
            { labelKey: `${KB}.ter.monthly.categoryLabel`, interpolation: { cat: "C" }, descKey: `${KB}.ter.monthly.categoryC` },
          ],
        },
        {
          title: `${KB}.ter.daily.title`,
          description: `${KB}.ter.daily.description`,
          layout: "label-value",
          items: [
            { labelKey: `${KB}.ter.daily.below450k`, value: "0%" },
            { labelKey: `${KB}.ter.daily.above450k`, value: "0,5%" },
          ],
        },
      ],
    },
    {
      type: "methods",
      title: `${KB}.howToCalculate.title`,
      description: `${KB}.howToCalculate.description`,
      methods: [
        {
          title: `${KB}.howToCalculate.permanent.title`,
          steps: [
            {
              labelKey: `${KB}.howToCalculate.permanent.regularPeriod`,
              formulaKey: `${KB}.howToCalculate.permanent.regularFormula`,
            },
            {
              labelKey: `${KB}.howToCalculate.permanent.lastPeriod`,
              formulaKey: `${KB}.howToCalculate.permanent.lastFormula`,
              noteKey: `${KB}.howToCalculate.permanent.lastNote`,
            },
          ],
        },
        {
          title: `${KB}.howToCalculate.nonPermanent.title`,
          rows: [
            {
              labelKey: `${KB}.howToCalculate.nonPermanent.dailyBelow`,
              formulaKey: `${KB}.howToCalculate.nonPermanent.dailyBelowFormula`,
            },
            {
              labelKey: `${KB}.howToCalculate.nonPermanent.dailyAbove`,
              formulaKey: `${KB}.howToCalculate.nonPermanent.dailyAboveFormula`,
            },
            {
              labelKey: `${KB}.howToCalculate.nonPermanent.monthly`,
              formulaKey: `${KB}.howToCalculate.nonPermanent.monthlyFormula`,
            },
          ],
        },
        {
          title: `${KB}.howToCalculate.nonEmployee.title`,
          formulaKey: `${KB}.howToCalculate.nonEmployee.formula`,
        },
      ],
    },
    {
      type: "table",
      title: `${KB}.pasal17.title`,
      description: `${KB}.pasal17.description`,
      headers: [`${KB}.pasal17.headerBracket`, `${KB}.pasal17.headerRate`],
      rows: [
        { cells: [{ key: `${KB}.pasal17.bracket1` }, { value: "5%" }] },
        { cells: [{ key: `${KB}.pasal17.bracket2` }, { value: "15%" }] },
        { cells: [{ key: `${KB}.pasal17.bracket3` }, { value: "25%" }] },
        { cells: [{ key: `${KB}.pasal17.bracket4` }, { value: "30%" }] },
        { cells: [{ key: `${KB}.pasal17.bracket5` }, { value: "35%" }] },
      ],
    },
    {
      type: "key-value",
      title: `${KB}.ptkp.title`,
      description: `${KB}.ptkp.description`,
      items: [
        { labelKey: `${KB}.ptkp.self`, amount: "Rp54.000.000" },
        { labelKey: `${KB}.ptkp.married`, amount: "Rp4.500.000" },
        { labelKey: `${KB}.ptkp.spouseIncome`, amount: "Rp54.000.000" },
        { labelKey: `${KB}.ptkp.dependent`, amount: "Rp4.500.000" },
      ],
      statusTitle: `${KB}.ptkp.shortStatusTitle`,
      statuses: [
        { status: "TK/0", amount: "Rp54.000.000" },
        { status: "K/0", amount: "Rp58.500.000" },
        { status: "K/1", amount: "Rp63.000.000" },
        { status: "K/2", amount: "Rp67.500.000" },
        { status: "K/3", amount: "Rp72.000.000" },
      ],
    },
    {
      type: "rate-info",
      title: `${KB}.pph26Section.title`,
      description: `${KB}.pph26Section.description`,
      rates: [
        { labelKey: `${KB}.pph26Section.rateLabel`, valueKey: `${KB}.pph26Section.rateValue` },
        { labelKey: `${KB}.pph26Section.specialLabel`, descKey: `${KB}.pph26Section.specialValue` },
      ],
    },
  ],
};
